import React from 'react';
import { Yes, No, UpArrow } from '../icons/Icons';

const PageFive = (props) => {
  return (
    <div className="kids-quiz__page">
      <div className="kids-quiz__question">
        <p className="question__title">Do you suffer with any of the below?</p>
        <div className="answers-row--flex health-answers">
          {props.renderConditionsAnswers}
        </div>
      </div>

      <a href="#eyesight" className="question-divider question-divider--show">
        <UpArrow />
      </a>

      <div id="eyesight" className="kids-quiz__question">
        <p className="question__title">Do you wear glasses or use contact lenses?</p>

        <div className="radio-answers answers-row--2">
          <input type="radio" name="glasses" id="glassesYes" value="yes" onChange={props.logGlassesAnswer} checked={props.glassesAnswer === 'yes'} />
          <label className="answer-button answer-button__glasses" htmlFor="glassesYes"><Yes />Yes</label>

          <input type="radio" name="glasses" id="glassesNo" value="no" onChange={props.logGlassesAnswer} checked={props.glassesAnswer === 'no'} />
          <label className="answer-button answer-button__glasses" htmlFor="glassesNo"><No />No</label>
        </div>
      </div>
      <div className={`next-page ${props.glassesAnswer ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('5')}>Continue</div>
    </div>
  );
}

export default PageFive;